/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { catchError, from, Observable, throwError } from 'rxjs';

import { Guid, HealthResponse, SM, Task, WikiDoc, WikiDocBase, IRequestSearch, VzFile, IdNameAvatar } from '@models';
import { HttpApiError } from '@models/api/http-api-error';
import { environment } from '@env/environment';
import { getHttpParams, ApiMethod, Get, Post, TResponseType, TVzResponse, VzServices, emitArray, sendRequest } from './http-helpers';

@Injectable({ providedIn: 'root' })
export class PublicApiService {

    private _http   = inject(HttpClient);

    private _baseUrl: string | undefined = environment.urls.api;
    private _authBaseUrl: string | undefined = environment.urls.auth;
    private _conf: SM<() => VzServices> = {};
    lastRequest: number = new Date().getTime();

    RD: SM<ApiMethod<any, any>>;
    private __req?: ApiMethod<any, any> | null;


    constructor() {
        this.RD = (this as any).__RD;
        // if (environment.env != 'prod' || INST == 'enterprise') {
        //     const bu = this._store.getItem('apiBaseUrl');
        //     if (bu) {
        //         this._baseUrl = bu;
        //     }
        // }
        console.log('constructor', 'baseUrl:', this._baseUrl);
        console.log('constructor', 'authBaseUrl:', this._authBaseUrl);
        const conf: () => VzServices = () => ({
            baseUrl: '',
            http: this._http,
            L: console.log,
            W: console.warn,
        });
        this._conf.api = () => ({ ...conf(), baseUrl: this._baseUrl! });
        this._conf.auth = () => ({ ...conf(), baseUrl: this._authBaseUrl! });
        this._conf.app = () => ({ ...conf(), baseUrl: './' });
    }

    sendRequest<T extends TVzResponse>(id: string, ...args: any[]): Observable<T> {
        return sendRequest(this.RD[id], this._conf[this.RD[id].cfg!] || this._conf.api, ...args);
    }

    getBaseUrl(reqId: string): string {
        const q = new Map<string, Task>();
        q.values()
        return (this._conf[this.RD[reqId].cfg!] || this._conf.api)().baseUrl;
    }

    // * ######################################################################################################### Health Check
    @Get('healthCheck', (service: string) => `/health/${service}`, {
        desc: 'Gets the state of the given Vizorro service',
        res: {
            errorTitle: 'Health check error',
            clazz: HealthResponse
        }
    }) // @ts-ignore
    healthCheck(service: string = 'tasks'): Observable<HealthResponse> {}



    // * ######################################################################################################### Org
    @Get('getOrgInfo', (orgId: Guid) => `/info/org/${orgId}`, {
        desc: 'Получить название и логотип организации',
        res: {
            errorTitle: 'Не удалось получить название и логотип организации',
            clazz: IdNameAvatar
        },
        cfg: 'auth'
    }) // @ts-ignore
    getOrgInfo(orgId: Guid): Observable<IdNameAvatar> {}



    // * ######################################################################################################### Wiki
    @Get('getWikiDocs', (orgId?: Guid | undefined, parentId?: Guid, projectId?: Guid) => `/wiki/doc`, {
        desc: 'Получить список документов Wiki',
        params: (orgId?: Guid, parentId?: Guid, projectId?: Guid) => getHttpParams({ orgId, parentId, projectId }),
        res: {
            errorTitle: 'Не удалось получить список документов Wiki',
            parser: emitArray(WikiDocBase)
        }
    }) // @ts-ignore
    getWikiDocs(orgId?: Guid, parentId?: Guid, projectId?: Guid): Observable<WikiDoc[]> {}

    @Post('searchWikiDocs', '/wiki/doc/search', {
        desc: 'Поиск в документах Wiki',
        body: (params: IRequestSearch) => params,
        res: {
            errorTitle: 'Ошибка поиска в документах Wiki',
            parser: emitArray(WikiDoc)
        }
    }) // @ts-ignore
    searchWikiDocs(params: IRequestSearch): Observable<WikiDoc[]> {}

    @Get('getWikiDoc', (id: string, version: number, hierarchy?: boolean) => `/wiki/doc/${id}/${version}`, {
        desc: 'Получить документ Wiki',
        params: (id: string, version: number, hierarchy?: boolean) => hierarchy ? { hierarchy: '1' } : undefined,
        res: {
            errorTitle: 'Не удалось получить документ Wiki',
            clazz: WikiDoc
        }
    }) // @ts-ignore
    getWikiDoc(id: string, version: number, hierarchy?: boolean): Observable<WikiDoc> {}



    // * ######################################################################################################### Files
    @Get('getFile', (id: string) => `/files/${id}/info`, {
        desc: 'Получить информацию о файле',
        res: {
            errorTitle: 'Не удалось получить информацию о файле',
            clazz: VzFile
        }
    }) // @ts-ignore
    getFile(id: string): Observable<VzFile> {}

    @Get('getFileContent', (id: string, preview?: 'img' | 'pdf') => `/files/${id}`, {
        desc: 'Получить содержимое файла',
        params: (id: string, preview?: 'img' | 'pdf') => preview ? { preview } : undefined,
        res: {
            errorTitle: 'Не удалось получить содержимое файла',
            type: 'blob'
        }
    }) // @ts-ignore
    getFileContent(id: string, preview?: 'img' | 'pdf'): Observable<Blob> {}

    @Get('getFileDownloadLink', (id: string) => `/files/${id}/link`, {
        desc: 'Получить ссылку для скачивания файла',
        res: {
            errorTitle: 'Не удалось получить ссылку для скачивания файла',
        }
    }) // @ts-ignore
    getFileDownloadLink(id: string): Observable<IVzFileDownloadLinks> {}



    // * ######################################################################################################### Helpers
    @Get('getAssetFile',
        (fn: string, responseType: TResponseType, errText: string) => `./assets/${fn}`, {
        desc: 'Получить содержимое файла',
        cfg: 'app',
        res: {
            type: (fn: string, responseType: TResponseType, errText: string) => responseType,
            errorTitle: (fn: string, responseType: TResponseType, errText: string) => errText
        }
    }) // @ts-ignore
    getAssetFile(fn: string, responseType: TResponseType, errText: string): Observable<any> {}

    getUrl(url: string): Observable<Blob> {
        const getFile = async (furl: string) => {
            const res = await fetch(furl, { method: 'GET', mode: 'cors' });
            return await res.blob();
        };
        return from(getFile(url)).pipe(catchError(err => throwError(() => new HttpApiError('Ошибка загрузки файла', err?.message || undefined))));
    }

}
